







import { defineComponent, computed } from "@vue/composition-api";

import store from "@/store";

export default defineComponent({
  name: "RegistrationRouteMessages",
  setup() {
    const errors = computed(() => store.state.registrationRoute.errors);
    const messages = computed(() => store.state.registrationRoute.messages);

    return {
      errors,
      messages,
    };
  },
});
